import Roles from "../../../core/Roles.json";

export interface RoleCategory {
    title: string
    icon: string
    slug: string
}

export const slugifyCategory = (title: string) =>
    title.toLowerCase().replace(/\s+/g, "-");

// The role categories (Base Data, Jobs, ...) used both by the group sidebar
// sub-menu and the roles editor, so slugs always match.
export const roleCategories: RoleCategory[] = Roles.map(g => ({
    title: g.title,
    icon: g.icon,
    slug: slugifyCategory(g.title),
}));

// synthetic access-restriction categories (not in Roles.json) used only on the
// user roles page. Each drives a "{X}All" grant + per-item "{prefix}-{id}" grants.
export const SOURCES_CATEGORY: RoleCategory = { title: "Sources", icon: "bullhorn", slug: "sources" };
export const JOBTYPES_CATEGORY: RoleCategory = { title: "Job Types", icon: "tags", slug: "job-types" };
export const METROS_CATEGORY: RoleCategory = { title: "Metros", icon: "location-dot", slug: "metros" };
export const TECHNICIANS_CATEGORY: RoleCategory = { title: "Technicians", icon: "user-helmet-safety", slug: "technicians" };

export const restrictionCategories: RoleCategory[] = [
    SOURCES_CATEGORY,
    JOBTYPES_CATEGORY,
    METROS_CATEGORY,
    TECHNICIANS_CATEGORY,
];

// categories shown on the user roles page: technicians only see technician roles;
// everyone else sees the access-restriction categories + all non-technician roles.
export const userRoleCategories = (isTech?: boolean): RoleCategory[] => {
    if (isTech) return roleCategories.filter(c => c.title == "Technician Roles");
    return [...restrictionCategories, ...roleCategories.filter(c => c.title != "Technician Roles")];
};

// categories shown on the user-group roles page: access-restriction categories + all role groups.
export const groupRoleCategories: RoleCategory[] = [...restrictionCategories, ...roleCategories];
